import {Component} from 'react';
import ReactDOM from 'react-dom';

const modalRoot = document.getElementById('dialog-root');

class Dialog extends Component {
    constructor(props) {
        super(props);
        this.layout = document.createElement('div');
        this.layout.className = "dialog-layout";
        this.dialog = document.createElement('div');
        this.dialog.className = "dialog-box";
        this.close = document.createElement('div');
        this.close.className = "dialog-close";
        this.close.onclick = this.props.close;
        this.layout.appendChild(this.dialog);
        this.dialog.appendChild(this.close);
    }

    componentDidMount() {
        modalRoot.appendChild(this.layout);
    }

    componentWillUnmount() {
        modalRoot.removeChild(this.layout);
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.dialog,
        );
    }
}

export default Dialog;
